import { forwardRef } from "react";

export const DragItem = forwardRef(({ id, children, ...props }, ref) => {
  return (
    <div {...props} ref={ref}>
      {children}
    </div>
  );
});
